<fc-general-modal [baseId]="baseId" [form]="form" [fcModalItemContext]="fcModalItemContext" (saveForm)="save()" (cancelForm)="onCancel()">

  <div [formGroup]="form">
    <mat-tab-group animationDuration="0ms" mat-align-tabs="start" class="tabs-default full-modal-tabs" [disableRipple]="true">
      <mat-tab label="Contact Info">
        <ng-template mat-tab-label>
          <span class="tab-label" translate>Contact Info</span>
          <mat-badge
            *ngIf="getFormValidationErrors(contactInfoGroup) as errorCount"
            [matBadge]="errorCount"
            matBadgeColor="warn"
            matBadgeSize="small"
            matBadgePosition="after"
          ></mat-badge>
        </ng-template>
        <div formGroupName="contactInfoGroup">
          <fc-corporation-list
            [baseId]="baseId"
            [form]="contactInfoGroup"
            [listItem]="listItem.Corporation"
            [isSubmitted]="isSubmitted"
            [itemContext]="fcModalItemContext"
          ></fc-corporation-list>

          <!-- Notes Control -->
          <div class="form-group full-control">
            <label
              for="{{ baseId }}-notes"
              translate
            >Notes</label>
            <textarea
              class="form-control"
              [ngClass]="{ error: showErrors(notesControl, isSubmitted), 'required': isRequired(notesControl) }"
              id="{{ baseId }}-notes"
              [maxlength]="fcListValidation.validations.Notes.MaxLength"
              formControlName="notes"
              rows="3"
            >
            </textarea>
            <div
              *ngIf="showErrors(notesControl, isSubmitted)"
              id="{{ baseId }}-warning-text-notes"
              class="incorrect-input"
              translate
            >
              {{ notesControl.errors | fcListValidation : 'Notes' }}
            </div>
          </div>
          <!-- Notes Control -->

          <!-- Inactive checkbox -->
          <div class="checkbox-group">
            <mat-checkbox
              id="{{ baseId }}-inactive-checkbox"
              formControlName="inactive"
              translate
            > Inactive
            </mat-checkbox>
          </div>
          <!-- Inactive checkbox -->
        </div>
      </mat-tab>

      <mat-tab label="Workers Comp">
        <ng-template mat-tab-label>
          <span class="tab-label" translate>Workers Comp</span>
          <mat-badge
            *ngIf="getFormValidationErrors(workersCompFormGroup) as errorCount"
            [matBadge]="errorCount"
            matBadgeColor="warn"
            matBadgeSize="small"
            matBadgePosition="after"
          ></mat-badge>
        </ng-template>
        <fc-workers-comp
          [baseId]="baseId"
          [form]="workersCompFormGroup"
          [isSubmitted]="isSubmitted"
          [itemContext]="fcModalItemContext"
          [listItem]="listItem.RelEmployerInsurancePlan"
        ></fc-workers-comp>
      </mat-tab>

    </mat-tab-group>
  </div>
</fc-general-modal>
